import {Button} from '@sollapay/ui/components';

import {formatBuyerDisplayName} from '../utils';
import {BuyerAvatar} from './BuyerAvatar';

import type {BuyerDTO} from '@sollapay/types';
import type {FC} from 'react';

export interface BuyerNameLinkProps {
  buyer: Pick<BuyerDTO, 'id' | 'fullName' | 'partyType'>;
  onClick: () => void;
}

export const BuyerNameLink: FC<BuyerNameLinkProps> = ({buyer, onClick}) => (
  <Button
    variant="linkColor"
    size="sm"
    className="group/name h-auto p-0 font-semibold text-fg hover:text-brand-accent hover:no-underline"
    onClick={onClick}
  >
    <div data-slot="buyer-name" className="flex items-center gap-2">
      <BuyerAvatar buyer={buyer} size="default" />
      <span className="decoration-1 underline-offset-4 group-hover/name:underline">
        {formatBuyerDisplayName(buyer.fullName)}
      </span>
    </div>
  </Button>
);
